












import { computed, defineComponent, ref } from "@vue/composition-api";
import { VaultCategory } from "@scrile/api-provider/dist/api/VaultsProvider";
import providers from "@/lib/api";
import { FormField } from "@/types";
import BasePromptConfirmation from "@/components/BasePromptConfirmation";

export default defineComponent({
  name: "VaultRenameCategoryModal",
  components: { BasePromptConfirmation },
  props: {
    value: { type: Boolean, required: true },
    selectedCategory: { type: Object as () => VaultCategory, required: true },
  },

  setup(props, { emit }) {
    const loading = ref(false);
    const inputProps = computed<Partial<FormField>>(() => ({
      value: props.selectedCategory.name,
      autofocus: true,
      rules: ["required"],
      class: "mb-5",
    }));

    const onRename = async (name: string) => {
      try {
        loading.value = true;
        const data = {
          id: props.selectedCategory.id,
          name: name.trim(),
        };
        const newCategory = await providers.VaultsProvider.updateCategory({ data });
        emit("update", newCategory);
        emit("close");
      } finally {
        loading.value = false;
      }
    };

    return { inputProps, loading, onRename };
  },
});
